import { BannerFormData, BannerListApiResponse, BannerGetApiResponse } from "../context/BannerContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-banner",
	UPDATE: "/cms/update-banner",
	REMOVE: "/cms/remove-banner",
	GET: "/cms/get-banner-details",
	LIST: "/cms/get-banner-list",
	ORDER: "/cms/update-banner-orders"
};

export class BannerService {
	static async addBanner(bannerData: BannerFormData) {
		const formData = new FormData();

		formData.append("isActive", bannerData.isActive ? "true" : "false");

		if (bannerData.images.image) {
			formData.append("image", bannerData.images.image);
		}

		if (bannerData.images.smallImage) {
			formData.append("smallImage", bannerData.images.smallImage);
		}

		formData.append("hasNavigation", bannerData.hasNavigation ? "true" : "false");

		if (bannerData.bannerLocalizable && bannerData.bannerLocalizable.length > 0) {
			bannerData.bannerLocalizable.forEach((item, index) => {
				formData.append(`bannerLocalizable[${index}].culture`, item.culture ?? "");
				formData.append(`bannerLocalizable[${index}].firstHeader`, item.firstHeader ?? "");
				formData.append(`bannerLocalizable[${index}].header`, item.header ?? "");
				if (item.url?.trim()) {
					formData.append(`bannerLocalizable[${index}].url`, item.url);
				}
			});
		}

		const response = await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
		return response.data;
	}

	static async getBannerList(): Promise<BannerListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.LIST);
		return response.data;
	}

	static async getBannerDetails(id: string): Promise<BannerGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?bannerId=${id}`);
		return response.data;
	}

	static async updateBanner(bannerData: BannerFormData) {
		const formData = new FormData();

		formData.append("bannerId", bannerData.bannerId ?? "");

		if (bannerData.isActive !== undefined) {
			formData.append("isActive", bannerData.isActive ? "true" : "false");
		}

		if (bannerData.images.image) {
			formData.append("image", bannerData.images.image);
		}

		if (bannerData.images.smallImage) {
			formData.append("smallImage", bannerData.images.smallImage);
		}

		if (bannerData.hasNavigation !== undefined) {
			formData.append("hasNavigation", bannerData.hasNavigation ? "true" : "false");
		}

		if (bannerData.bannerLocalizable && bannerData.bannerLocalizable.length > 0) {
			bannerData.bannerLocalizable.forEach((item, index) => {
				if (item.bannerLocalizableId?.trim()) {
					formData.append(`bannerLocalizable[${index}].bannerLocalizableId`, item.bannerLocalizableId);
				}

				if (item.culture?.trim()) {
					formData.append(`bannerLocalizable[${index}].culture`, item.culture);
				}

				if (item.firstHeader?.trim()) {
					formData.append(`bannerLocalizable[${index}].firstHeader`, item.firstHeader);
				}

				if (item.header?.trim()) {
					formData.append(`bannerLocalizable[${index}].header`, item.header);
				}

				if (item.url?.trim()) {
					formData.append(`bannerLocalizable[${index}].url`, item.url ?? "");
				}
			});
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}

	static async removeBanner(id: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?bannerId=${id}`);
		return response.data;
	}

	static async updateBannerOrders(bannerList: Array<{ bannerId: string; displayOrder: number }>) {
		const formData = new FormData();

		bannerList.forEach((item, index) => {
			formData.append(`bannerList[${index}].bannerId`, item.bannerId || "");
			formData.append(`bannerList[${index}].displayOrder`, item.displayOrder.toString() || "");
		});

		const response = await axiosInstance.put(`${ENDPOINTS.ORDER}`, formData);
		return response.data;
	}
}